import {useEffect, useState} from 'react';
import {Box, Grid, Typography} from '@mui/material';
import * as moment from 'moment';
import {getStoredSession} from '../../LocalStorageService';
import {useStyles} from '../../utils/uiUtils';
import {UserBadge} from '../user/UserBadge';
import {AddressPicker} from '../address/AddressPicker';

const ReadOnlyField = ({label, value, classes, inline = true}) => (
    <>
        <Grid container direction='row' justifyContent='flex-start' spacing={2} alignItems="center">
            <Grid item style={{minWidth: '200px'}}>
                <Typography align='left' className={classes.labelMuted}>{label}</Typography>
            </Grid>
            {inline && <Grid item style={{textAlign: 'left'}}>
                <Typography className={classes.valueWhite}>{value}</Typography>
            </Grid>}
        </Grid>
        {!inline && <Grid item style={{textAlign: 'left'}}>
            <Typography className={classes.valueWhite} sx={{whiteSpace: 'pre-wrap'}}>{value}</Typography>
        </Grid>}
    </>
);

const billingLabelMap = {
    monthly: "Monthly",
    quarterly: "Quarterly",
    half_yearly: "Half Yearly",
    annually: "Annually",
    other: "Other",
};

export const JobSummary = ({orderDetail, customer, companyCode, displayBilling = false}) => {
    const classes = useStyles();
    const [logInUser, setLogInUser] = useState();
    useEffect(() => {
        setLogInUser(getStoredSession());
    }, []);

    const jobIdentifier = companyCode && orderDetail.tapeark_job_id > 0
        ? `${companyCode}-${String(orderDetail.tapeark_job_id).padStart(3, '0')}`
        : null;

    return (
        <Box p={2}>
            <Grid container direction='column' spacing={1} xs={8}>
                <Grid item>
                    <Typography align='left' className={classes.headingLarge}>Job Details</Typography>
                </Grid>
                <Grid item xs={4}>
                    <ReadOnlyField label="Job ID" value={jobIdentifier ? `${orderDetail.order_number} (${jobIdentifier})` : orderDetail.order_number} classes={classes}/>
                    <hr className={classes.dividerSubtle}/>
                </Grid>
                <Grid item xs={4}>
                    <ReadOnlyField label="Client Name" value={orderDetail.customer_name} classes={classes}/>
                    <hr className={classes.dividerSubtle}/>
                </Grid>
                {customer?.contact_address && (
                    <Grid item xs={4}>
                        <Grid container direction='row' justifyContent='flex-start' spacing={2} alignItems="center">
                            <Grid item style={{minWidth: '200px'}}>
                                <Typography align='left' className={classes.labelMuted}>Client Address</Typography>
                            </Grid>
                            <Grid item>
                                <AddressPicker value={customer.contact_address} canToggle={true} active={false}/>
                            </Grid>
                        </Grid>
                        <hr className={classes.dividerSubtle}/>
                    </Grid>
                )}
                <Grid item xs={4}>
                    <ReadOnlyField label="TapeArk Client ID" value={customer?.arkbridge_customer_id || logInUser?.user?.arkbridge_customer_id} classes={classes}/>
                    <hr className={classes.dividerSubtle}/>
                </Grid>
                <Grid item xs={4}>
                    <ReadOnlyField label="TapeArk Job ID" value={orderDetail.tapeark_job_id} classes={classes}/>
                    <hr className={classes.dividerSubtle}/>
                </Grid>
                <Grid item>
                    <ReadOnlyField label="Quote Reference ID" value={orderDetail.quote_reference_id} classes={classes}/>
                    <hr className={classes.dividerSubtle}/>
                </Grid>
                <Grid item>
                    <Grid container direction='row' justifyContent='flex-start' spacing={2} alignItems="center">
                        <Grid item style={{minWidth: '200px'}}>
                            <Typography align='left' className={classes.labelMuted}>Contact Person</Typography>
                        </Grid>
                        <Grid item>
                            <UserBadge value={customer?.email || orderDetail?.customer_email}/>
                        </Grid>
                    </Grid>
                    <hr className={classes.dividerSubtle}/>
                </Grid>
                <Grid item>
                    <ReadOnlyField label="Project Scope" value={orderDetail.project_scope} classes={classes} inline={false}/>
                    <hr className={classes.dividerSubtle}/>
                </Grid>
                <Grid item>
                    <ReadOnlyField label="Project Deliverables" value={orderDetail.project_deliverables} classes={classes} inline={false}/>
                    <hr className={classes.dividerSubtle}/>
                </Grid>
                <Grid item>
                    <ReadOnlyField label="Security and Privacy Evaluation and Assessment" value={orderDetail.job_security_privacy} classes={classes}/>
                    <hr className={classes.dividerSubtle}/>
                </Grid>
                <Grid item>
                    <ReadOnlyField label="SOW Commence" value={orderDetail.sow_start ? moment(orderDetail.sow_start).format("MMM/DD/YYYY") : ""} classes={classes}/>
                    <hr className={classes.dividerSubtle}/>
                </Grid>
                <Grid item>
                    <ReadOnlyField label="SOW Completion" value={orderDetail.sow_end ? moment(orderDetail.sow_end).format("MMM/DD/YYYY") : ""} classes={classes}/>
                    <hr className={classes.dividerSubtle}/>
                </Grid>
                {displayBilling && (
                    <Grid item>
                        <ReadOnlyField label="Billing" value={billingLabelMap[orderDetail.billing] || orderDetail.billing} classes={classes}/>
                        <hr className={classes.dividerSubtle}/>
                        {orderDetail.billing === 'other' && orderDetail.billing_description && (
                            <ReadOnlyField label="Billing Description" value={orderDetail.billing_description} classes={classes} inline={false}/>
                        )}
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};
